// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'inbox-solid';

export const Component = () => (
  <path d='M23.467 13.734h-7.47v.526a3.658 3.658 0 0 1-1.102 2.635 3.656 3.656 0 0 1-2.635 1.101 3.658 3.658 0 0 1-2.634-1.101 3.656 3.656 0 0 1-1.102-2.635v-.526h-7.47L4.788 3.102H19.73l3.736 10.632Zm1.054 0L20.26 2H4.262L0 13.734v9.626h24.521v-9.626Z' />
);

export const viewBox = '0 0 25 25';
